<template>
  <div class="main">
    <div class="baseInfo">
      <div class="baseInfoTitle">
        <div class="line"/>
        <span>基础信息</span>
      </div>
      <div class="baseInfoContent">
        <div class="baseInfoContentItem">
          <span class="span1">登录账号：</span>
          <span>{{baseInfo.account}}</span>
        </div>
        <div class="baseInfoContentItem">
          <span class="span1">真实姓名：</span>
          <span>{{baseInfo.empNm}}</span>
        </div>
        <div class="baseInfoContentItem specialItem">
          <div class="specialOne">
            <span class="span1">性别：</span>
            <span>{{baseInfo.empGender==1?'男':'女'}}</span>
          </div>
          <div>
            <span class="span1">年龄：</span>
            <span>{{baseInfo.age}}</span>
          </div>
        </div>
        <div class="baseInfoContentItem">
          <span class="span1">邮箱：</span>
          <span>{{baseInfo.email}}</span>
        </div>
        <div class="baseInfoContentItem specialItem">
          <div class="specialOne">
            <span class="span1">所在公司：</span>
            <span>{{baseInfo.fullName}}</span>
          </div>
          <div>
            <span class="span1">所在部门：</span>
            <span>{{baseInfo.depNm}}</span>
          </div>
        </div>
        <div class="baseInfoContentItem">
          <span class="span1">角色：</span>
          <span>{{baseInfo.roleNm}}</span>
        </div>
        <div class="baseInfoContentItem">
          <span class="span1">创建时间：</span>
          <span>{{baseInfo.createTime}}</span>
        </div>
      </div>
    </div>
    <div class="operation">
      <div class="baseInfoTitle">
        <div class="line"/>
        <span>基础信息</span>
      </div>
      <div class="tableContainer">
        <el-table :data="baseInfo.operateRecordList" border size="mini" v-loading="loading">
          <el-table-column prop="createTime" label="操作时间" width="150" align="center"/>
          <el-table-column prop="operateType" label="操作类型" align="center"/>
          <el-table-column prop="operationName" label="操作人" align="center"/>
          <el-table-column prop="remark" label="备注" align="center"/>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { essEmployeeGetUserInfo } from '@/service/getData';

export default {
  data() {
    return {
      baseInfo: {},
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    this._essEmployeeGetUserInfo();
  },
  methods: {
    async _essEmployeeGetUserInfo() {
      const res = await essEmployeeGetUserInfo();
      if (res.status !== 0) return this.$message.error(res.message);
      this.baseInfo = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.main{
  width:100%;
  display:flex;
  flex-direction:column;
  align-items:center;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .baseInfo{
    width:600px;
    margin-top:70px;
    &Title{
      display:flex;
      align-items:flex-end;
    }
    &Content{
      display:flex;
      flex-direction: column;
      justify-content: space-between;
      padding:20px 23px 0 23px;
      &Item{
        margin-bottom: 20px;
        span{
          color: rgba(16, 16, 16, 100);
          font-size: 14px;
        }
        .specialOne{
          width:60%;
        }
      }
      .specialItem{
        display:flex;
      }
    }
  }
  .operation{
    width:600px;
    padding-bottom: 60px;
    .tableContainer{
      padding:20px 23px 0 23px;
    }
  }
}
</style>
